// extracted by mini-css-extract-plugin
export default {"marketsCell":"styles_marketsCell__m9yWD","marketsCell__expanded":"styles_marketsCell__expanded__8lK2z","marketCell__empty":"styles_marketCell__empty__cUZjl"};